import { Modal as a } from "./modal.js";
export {
  a as Modal
};
